import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import { autheliaAuthApiRef } from './autheliaAuthApi';

const autheliaProvider = {
  id: 'authelia-oidc-provider',
  title: 'Authelia',
  message: 'Sign in using Authelia OIDC',
  apiRef: autheliaAuthApiRef,
  enableExperimentalRedirectFlow: true,
};

// Guest sign-in is offered only in local development, where running Authelia is
// impractical. Bundling for production sets NODE_ENV=production, so this branch
// is dropped from the deployed bundle and the sign-in page stays Authelia-only.
// The matching backend module is gated the same way in packages/backend/src/index.ts.
const isDevelopment = process.env.NODE_ENV === 'development';

export const customSignInPage = SignInPageBlueprint.make({
  params: {
    loader: async () => props =>
      isDevelopment ? (
        <SignInPage {...props} providers={['guest', autheliaProvider]} />
      ) : (
        <SignInPage {...props} provider={autheliaProvider} />
      ),
  },
});
